import { render, staticRenderFns } from "./AttachmentIcon.vue?vue&type=template&id=f12f999e&scoped=true&"
import script from "./AttachmentIcon.vue?vue&type=script&lang=js&"
export * from "./AttachmentIcon.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentIcon.vue?vue&type=style&index=0&id=f12f999e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12f999e",
  null
  
)

export default component.exports